// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.invite-earn[data-v-1606c4a2] {\n    transition: opacity 0.3s ease;\n}\n.invite-earn.dimmed[data-v-1606c4a2] {\n    opacity: 0.7;\n}\n.invite-earn.hovered[data-v-1606c4a2] {\n    cursor: pointer;\n    opacity: 1;\n    z-index: 2;\n    transform: scale(1.02);\n    transition: all 0.3s ease-in-out;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
